import axios from "../axiosInstance";

class NotificacoesService {
  async obterNotificacoes() {
    return await axios.get("/notificacoes/notificacoesvuupt");
  }

  async registrarVisualizacaoNotificacoes(dataVisualizacao) {
    return await axios.post("/notificacoes/visualizar", null, {
      params: {
        dataVisualizacao,
      },
    });
  }
}
export default new NotificacoesService();
